import L from 'leaflet';

// SVG icon definitions for FTZ map markers
export const MAP_ICON_SVGS = {
  warehouse: `
    <svg width="25" height="41" viewBox="0 0 25 41" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5 0C5.6 0 0 5.6 0 12.5c0 7.4 12.5 28.5 12.5 28.5s12.5-21.1 12.5-28.5C25 5.6 19.4 0 12.5 0z" fill="#0B494B" stroke="#fff" stroke-width="2"/>
      <circle cx="12.5" cy="12.5" r="5" fill="#fff"/>
    </svg>
  `,
  ftz: `
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="8" fill="#800080" stroke="#fff" stroke-width="2"/>
      <text x="10" y="14" text-anchor="middle" fill="white" font-size="8" font-weight="bold">F</text>
    </svg>
  `,
  nearbyFtz: `
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="8" fill="#00FF00" stroke="#fff" stroke-width="2"/>
      <text x="10" y="14" text-anchor="middle" fill="white" font-size="8" font-weight="bold">F</text>
    </svg>
  `
};

// Icon configurations
export const MAP_ICONS = {
  port: new L.Icon({
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
    className: 'port-marker'
  }),

  warehouse: new L.Icon({
    iconUrl: 'data:image/svg+xml;base64,' + btoa(MAP_ICON_SVGS.warehouse),
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
  }),

  ftz: new L.Icon({
    iconUrl: 'data:image/svg+xml;base64,' + btoa(MAP_ICON_SVGS.ftz),
    iconSize: [20, 20],
    iconAnchor: [10, 10],
    popupAnchor: [0, -10],
  }),

  nearbyFtz: new L.Icon({
    iconUrl: 'data:image/svg+xml;base64,' + btoa(MAP_ICON_SVGS.nearbyFtz),
    iconSize: [20, 20],
    iconAnchor: [10, 10],
    popupAnchor: [0, -10],
  })
};

// Map configuration constants
export const MAP_CONFIG = {
  RADIUS_IN_MILES: 60,
  DEFAULT_CENTER: [39.8283, -98.5795] as [number, number], // US center
  DEFAULT_ZOOM: 4,
  WAREHOUSE_ZOOM: 8
}; 